import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { Provider } from "react-redux";
import { createStore } from "redux";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

// const store = createStore();

ReactDOM.render(
//   <Provider store={store}>
    <Router>
      <App />
    </Router>
//   </Provider>
  ,document.getElementById("root")
);
